import React, { useState } from 'react';
import css from './SectionAllowedActivities.module.css';

const INITIAL_COUNT = 6;

const SectionAllowedActivities = ({ options, selectedOptions, heading }) => {
  const [showAll, setShowAll] = useState(false);

  if (!options || options.length === 0) return null;

  const selected = selectedOptions || [];
  const allowed = options.filter(o => selected.includes(o.key));
  const notAllowed = options.filter(o => !selected.includes(o.key));

  if (allowed.length === 0 && notAllowed.length === 0) return null;

  const allItems = [
    ...allowed.map(o => ({ ...o, permitted: true })),
    ...notAllowed.map(o => ({ ...o, permitted: false })),
  ];
  const hasMore = notAllowed.length > 0;
  const visibleItems = showAll ? allItems : allowed.map(o => ({ ...o, permitted: true }));

  const inner = (
    <>
      {visibleItems.length > 0 ? (
        <div className={`${css.grid}${!showAll ? ` ${css.gridCollapsed}` : ''}`}>
          {visibleItems.map(o => (
            <div key={o.key} className={o.permitted ? css.item : `${css.item} ${css.itemDisabled}`}>
              {o.permitted ? <span className={css.checkmark}>✓</span> : null}
              <span>{o.label}</span>
            </div>
          ))}
        </div>
      ) : null}
      {hasMore ? (
        <button type="button" className={css.showAllBtn} onClick={() => setShowAll(s => !s)}>
          {showAll ? 'Show less' : 'Show all activities'}
        </button>
      ) : null}
    </>
  );

  if (heading) {
    return (
      <section className={css.root}>
        <h2 className={css.heading}>{heading}</h2>
        {inner}
      </section>
    );
  }

  return <div>{inner}</div>;
};

export default SectionAllowedActivities;
